/**
 * MKS-332 — the Portfolio table's column template, in one place.
 *
 * The header, the data row and the group row must agree on the grid or the
 * columns visibly misalign, and the Margin column now comes and goes with the
 * viewer's role (admin/finance only). Three copies of the template string that
 * each had to grow a conditional was three chances to get it wrong.
 *
 * Both variants are written out as LITERAL class strings rather than built by
 * interpolation: Tailwind's JIT scans source text, so a computed arbitrary
 * value like `grid-cols-[${cols}]` produces no CSS at all.
 *
 * Columns: Project | Status | Burn | Revenue | [Margin] | Team | Due
 */
const WITH_MARGIN = 'grid grid-cols-[1fr_120px_200px_100px_90px_110px_110px]';
const WITHOUT_MARGIN = 'grid grid-cols-[1fr_120px_200px_100px_110px_110px]';

export function portfolioGridClass(showMargin: boolean): string {
  return showMargin ? WITH_MARGIN : WITHOUT_MARGIN;
}
